export default __webpack_public_path__ + "static/media/LAS0780.34I-37189_-22006_0.c0eb88ac.jpg";